var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{class:_vm.getThemeColor +
      ' question-fyi ' +
      (_vm.identifier ? ' indented-question' : '')},[_vm._v(" "+_vm._s(_vm.identifier)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.value.text.replace(/\r?\n/g, '<br/>'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }